<div class="login">
    <div class="main-container">
        <div class="login-container ">
            <div class="login__form-side">
                <div class="login-image">
                    <img style="width: 90px; max-width: none;" src="./assets/images/logos/erx-logo.svg" alt="erx logo"
                        class="img-fluid" >
                </div>
                <div class="login-form" *ngIf="!Forgot">
                    <h5>LOGIN</h5>
                    <form name="loginForm" [formGroup]="loginForm" autocomplete="off">
                        <div class="form-group">
                            <input type="text" class="form-control-login" formControlName="username"
                                [ngClass]="{'is-invalid' : submitted && controls?.['username']?.errors?.['required'] }"
                                required id="user-name" appPreventFirstSpace>
                            <label for="user-name" class="input-label">USER NAME</label>
                            <div class="invalid-feedback d-block"
                                *ngIf="submitted && controls?.['username']?.errors?.['required']">
                                Please choose a username.
                            </div>
                        </div>
                        <div class="form-group password ">
                            <input [type]="(this.showPassword)?'text':'password'" class="form-control-login"
                                formControlName="password"
                                [ngClass]="{'is-invalid' : submitted && controls?.['password']?.errors?.['required'] }"
                                required id="password" appPreventFirstSpace>
                            <label for="password" class="input-label">Password</label>
                            <div class="pw-icon show-password" [ngClass]="{'hide-password': !showPassword}"
                                (click)="this.showPassword=!this.showPassword"></div>
                            <div class="invalid-feedback d-block"
                                *ngIf="submitted && controls?.['password']?.errors?.['required']">
                                Please choose a Password.
                            </div>
                        </div>
                        <div class="form-group">
                            <div [ngClass]="{'is-invalid' :submitted && controls?.['userType']?.errors?.['required']}">
                                <app-single-select uid="id" [searchShow]=false [dataArr]="dummyUserTypes"
                                    (selectedEvent)="selectedValue($event,'userType');" label="name"
                                    [selectedData]="loginForm.value.userType" [placeholder]="'User Type'">
                                </app-single-select>
                            </div>
                            <div class="invalid-feedback d-block"
                                *ngIf="submitted && controls?.['userType']?.errors?.['required']">
                                Confirm your user type.
                            </div>
                        </div>
                        <button type="submit" class="btn btn-darkblue" (click)="userLogin()">Login</button>
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="form-check d-flex ">
                                <input class="form-check-input" type="checkbox" id="remember-me" name="deliveryItems">
                                <label class="form-check-label link" for="remember-me">Remember Me</label>
                            </div>
                            <a class="link" (click)="toggleForForgot(true)">Forgot Password?</a>
                        </div>
                    </form>
                </div>
                <div class="login-form" *ngIf="Forgot">
                    <div class="login-form" *ngIf="!mailsuccess">
                        <h5>Forgot Your Password?</h5>
                        <p>Please enter the email address registered with<br />your PBM Portal</p>
                        <form [formGroup]="forgotForm" autocomplete="off">
                            <div class="form-group">
                                <input type="text" class="form-control-login" required id="user-name-forgot"
                                    formControlName="email"
                                    [ngClass]="{'is-invalid' : forgotSubmitted && (forgotForm.controls['email'].errors?.['required']||forgotForm.controls['email'].errors?.['email']) }"
                                    required appPreventFirstSpace>
                                <label for="user-name" class="input-label">ENTER EMAIL ADDRESS</label>
                                <div class="invalid-feedback d-block"
                                    *ngIf="forgotSubmitted && forgotForm.controls?.['email']?.errors?.['required']">
                                    Please enter a email address.
                                </div>
                                <div class="invalid-feedback d-block"
                                    *ngIf="forgotSubmitted && (!forgotForm.controls['email']?.errors?.['required']) && (forgotForm.controls['email']?.errors?.['email'])">
                                    Please choose valid email.
                                </div>
                            </div>
                            <button type="submit" class="btn btn-darkblue" (click)="forgotPassword()">RESET
                                PASSWORD</button>

                        </form>
                    </div>
                    <div class="email-message" *ngIf="mailsuccess">
                        <img src="assets/images/icons/success-icon.svg" alt="success">
                        <h2>Email Sent</h2>
                        <p>An email has been imitated to your email address with the new password. Kindly login using
                            the new credential.</p>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn back-btn" (click)="toggleForForgot(false)">BACK TO
                            LOGIN</button>
                    </div>
                </div>
            </div>
            <div class="login__img-side">
                <h1>
                    Automate and integrate workflows to optimize efficiency
                </h1>
            </div>
        </div>
    </div>
</div>